import { HistoryModel } from '../models/history.model';
import { SynchronizationModel } from 'src/app/story/models/synchronization.model';

export class AddHistory {
  static readonly type = '[History] Add history';
  constructor(
    public history: HistoryModel
  ) { }
}

export class Undo {
  static readonly type = '[History] Undo';
  constructor(
    public count: number = 1
  ) { }
}

export class Redo {
  static readonly type = '[History] Redo';
  constructor(
    public count: number = 1
  ) { }
}

export class ResetHistory {
  static readonly type = '[History] Reset';
  constructor() { }
}

export class ClearHistory {
  static readonly type = '[History] Clear';
  constructor() { }
}

export class CacheChapterSynchronization {
  static readonly type = '[History] Cache Chapter Synchronization';
  constructor(public cacheId: string, public chapterId: string, public synchronization: SynchronizationModel, public readOnly = false) { }
}

export class RevertChapterSynchronization {
  static readonly type = '[History] Revert Chapter Synchronization';
  constructor(public cacheId: string, public chapterId: string) { }
}

export class CopyChapterSynchronization {
  static readonly type = '[History] Copy Chapter Synchronization';
  constructor(public sourceCacheId: string, public sourceChapterId: string, public targetCacheId: string, public targetChapterId: string) { }
}

export class RemoveChapterSynchronization {
  static readonly type = '[History] Remove Chapter Synchronization';
  constructor(public cacheId: string, public chapterId: string) { }
}
